import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper)
import 'swiper/css/swiper.css'

import axios from "@/axios";
Vue.prototype.$axios = axios

import 'github-markdown-css'

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'LIqgyoq8PfXKnAGxKGTUuBuwYKfsFwuH'
});

import 'animate.css'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
